import React from 'react';
import { CheckIcon } from 'lucide-react';
import { USE_WAYS } from '../data/content';
export function UseItYourWay() {
  return <section aria-labelledby="use-title" className="w-full bg-white px-3 py-6 sm:px-5" data-id="element-250" data-mp="1dy1gh239o2k">
      <div className="mx-auto max-w-4xl text-center" data-id="element-251" data-mp="3sm2du5snpx88">
        <h2 id="use-title" className="font-head text-2xl uppercase leading-[0.98] text-navy sm:text-4xl" data-id="element-252" data-mp="3nlxxqgvnv4ij">
          Use it your way
        </h2>
        <p className="mt-1 text-[13px] leading-snug text-muted sm:text-base" data-id="element-253" data-mp="p395q8ine0lg">
          KIDS LEARNING READY™ adapts to how and where learning happens.
        </p>

        <ul className="mt-3 grid gap-1.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-254" data-mp="f5uo45kzn5rk">
          {USE_WAYS.map(item => <li key={item} className="flex items-start gap-1.5 rounded-lg border border-green/30 bg-green/5 px-2.5 py-1.5 text-[12px] font-semibold leading-snug text-navy sm:text-[13px]" data-id="element-255" data-mp="a79wgujsxueq">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green" aria-hidden="true" data-id="element-256" data-mp="2ux8w8gqp0x69" />
              {item}
            </li>)}
        </ul>

        <p className="mt-3 font-head text-lg uppercase leading-tight text-green sm:text-2xl" data-id="element-257" data-mp="2ejkitikznh7i">
          Print it. Teach it. Review it. Reuse it.
        </p>
      </div>
    </section>;
}